import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76ec3e91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-group" }

import {computed, ref, watch} from 'vue';

interface Props {
	buttonsPerRow: number;
	totalButtons: number;
	selectedItem?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonGroup',
  props: {
    buttonsPerRow: {},
    totalButtons: {},
    selectedItem: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "49a80d21": (_ctx.buttonsPerRow),
  "498b0356": (activeItem.value),
  "f666b894": (rows.value),
  "397f9ffa": (col.value),
  "397f2f46": (row.value)
}))

const props = __props;
const activeItem = ref(0);

const row = computed(() => Math.floor(props.selectedItem / props.buttonsPerRow));
const col = computed(() => props.selectedItem % props.buttonsPerRow);
const rows = ref(Math.ceil(props.totalButtons / props.buttonsPerRow));

watch( props, ({ selectedItem } ) => {
	activeItem.value = selectedItem;
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})